import { observable, action, computed, configure, runInAction } from 'mobx';
import { createContext } from 'react';
import { ITechnicianCertificate } from '../models/techniciancertificate';
import { ICertificate } from '../models/certificate';
import { toast } from 'react-toastify';
import agent from '../api/agent';

configure({enforceActions: 'always'});

class EmployeeCertificateStore {
  @observable employeecertificateRegistry = new Map();
  @observable employeecertificate: ITechnicianCertificate | null = null;
  @observable certificateRegistry = new Map();
  @observable employeecertificatephotoRegistry = new Map();
  @observable photouploadCount = new Map();
  @observable certificate: ICertificate | null = null;
  @observable loadingInitial = false;
  @observable submitting = false;
  @observable uploadingFile = false;
  @observable target = '';

  @computed get employeecertificatesByDate() {
    return Array.from(this.employeecertificateRegistry.values()).sort(
      (a, b) => a.id - b.id)
    ;
  }

  @computed get certificatesByName() {
    return Array.from(this.certificateRegistry.values()).sort(
      (a, b) => a.name.localeCompare(b.name))
    ;
  }

  @computed get employeecertificatephotosById() {
    return Array.from(this.employeecertificatephotoRegistry.values())
    ;
  }

  @action loadEmployeeCertificates = async () => {
    this.loadingInitial = true;
    try {
      const employeecertificates = await agent.EmployeeCertificates.list();
      runInAction('loading techniciancertificates', () => {
        this.employeecertificateRegistry.clear();
        employeecertificates.forEach(employeecertificate => {         
          if (employeecertificate.expiryDate !== null)  employeecertificate.expiryDate = employeecertificate.expiryDate.substr(0,10);
          this.employeecertificateRegistry.set(employeecertificate.id, employeecertificate);
        });
        this.loadingInitial = false;
      })

    } catch (error) {
      runInAction('load TechnicianCertificate List error', () => {
        this.loadingInitial = false;
      })
      toast.error('load TechnicianCertificate List error');
    }
  };

  @action clearTechnicianCertificate = () => {
    this.employeecertificate = null;
  }

  getTechnicianCertificate = (id: string) => {
    return this.employeecertificateRegistry.get(Number(id));
  }

  // @action createTechnicianCertificate = async (employeecertificate: ITechnicianCertificate) => {
  //   this.submitting = true;
  //   try {
  //     employeecertificate.createdAt = new Date().toJSON();
  //     employeecertificate.updatedAt = new Date().toJSON();
  //     const techniciancertificatename = await agent.TechnicianCertificates.create(employeecertificate);
  //     runInAction('create Techncian', () => {
  //       this.employeecertificatenameRegistry.clear();
  //         this.techniciancertificatename = techniciancertificatename;
  //         if (techniciancertificatename.expiryDate !== null)  techniciancertificatename.expiryDate = techniciancertificatename.expiryDate.substr(0,10);
  //         this.employeecertificatenameRegistry.set(techniciancertificatename.id, techniciancertificatename);
  //       this.submitting = false;
  //     })
  //   } catch (error) {
  //     runInAction('create TechnicianCertificate error', () => {
  //       this.submitting = false;
  //     })
  //     toast.error('create TechnicianCertificate error');
  //     console.log(error);
  //   }
  // };

  @action createEmployeeCertificate = async (employeecertificate: ITechnicianCertificate) => {
    this.submitting = true;
    try {
      await agent.EmployeeCertificates.create(employeecertificate);
      runInAction('create Employee Certificate', () => {
        this.submitting = false;
      })
    } catch (error) {
      runInAction('create Employee Certificate error', () => {
        this.submitting = false;
      })
      toast.error('create Employee Certificate error');
      console.log(error);
    }
  };

  @action editEmployeeCertificate = async (employeecertificate: ITechnicianCertificate) => {
    this.submitting = true;
    try {
      employeecertificate.verified = 'N';
      await agent.EmployeeCertificates.update(employeecertificate);
      runInAction('editing employeecertificate', () => {
        this.employeecertificateRegistry.set(employeecertificate.id, employeecertificate);
        this.employeecertificate = employeecertificate;
        this.submitting = false;
      })
    } catch (error) {
      runInAction('edit employeecertificate error', () => {
        this.submitting = false;
      })
      toast.error('edit employeecertificate error');
      console.log(error);
    }
  };

  @action deleteEmployeeCertificate = async (id: string) => {
    this.submitting = true;
    this.target = id;
    try {
      await agent.TechnicianCertificates.delete(id);
      runInAction('deleting TechnicianCertificate', () => {
        this.employeecertificateRegistry.delete(id);
        this.submitting = false;
        this.target = '';
      })
    } catch (error) {
      runInAction('delete TechnicianCertificate error', () => {
        this.submitting = false;
        this.target = '';
      })
      toast.error('delete TechnicianCertificate error');
      console.log(error);
    }
  }

@action loadCertificates = async () => {
  this.loadingInitial = true;
  try {
    const certificates = await agent.Certificates.list();
    runInAction('loading certificates', () => {
      certificates.forEach(certificate => {
        this.certificateRegistry.set(certificate.id, certificate);
      });
      this.loadingInitial = false;
    })

  } catch (error) {
    runInAction('load Certificate List error', () => {
      this.loadingInitial = false;
    })
    toast.error('load Certificate List error');
  }
};

@action uploadPhoto = async (photo : File[], name : string, category : string) => {
  if (typeof photo !== 'undefined' && photo.length > 0) 
  {  
    this.uploadingFile = true;   
  try {
    // var photos : File[] = [];
    // photos.push(photo);
    const photoreturn = await agent.Uploads.uploadPhoto(photo, name, category);
    runInAction(() => {
    this.photouploadCount.set(name, photoreturn.count);
     this.uploadingFile = false;
     toast.success('Photo uploaded successfully!');
    });
  } catch (error) {
    console.log(error);
    toast.error('Problem uploading photo');
    runInAction(() => {
      this.uploadingFile = false;
    });
  }
}
};

@action loadEmployeeCertificatePhoto = async (email: string, certificateId: string) => {
  this.loadingInitial = true;
  try {
    const techniciancertificatephotos = await agent.TechnicianCertificatePhotos.list(email, certificateId);
    runInAction('loading techniciancertificate photos', () => {
      this.employeecertificatephotoRegistry.clear();
      techniciancertificatephotos.forEach(techniciancertificatephoto => {
        this.employeecertificatephotoRegistry.set(techniciancertificatephoto.id, techniciancertificatephoto);
      });
      this.loadingInitial = false;
    })
  } catch (error) {
    runInAction('get techniciancertificate photo error', () => {
      this.loadingInitial = false;
    })
    toast.error('get techniciancertificate photo error');
    console.log(error);
  }
}

@action deleteEmployeeCertificatePhoto = async (id: string) => {
  this.submitting = true;
  this.target = id;
  try {
    await agent.TechnicianCertificatePhotos.delete(id);
    runInAction('deleting Employee Certificate photo', () => {
      this.employeecertificatephotoRegistry.delete(id);
      this.submitting = false;
      this.target = '';
      toast.success('Certificate photo deleted');
    })
  } catch (error) {
    runInAction('delete Employee Certificate photo error', () => {
      this.submitting = false;
      this.target = '';
    })
    toast.error('delete Employee Certificate photo error');
    console.log(error);
  }
}

@action changeEmployeeCertificate = async (techniciancertificate: ITechnicianCertificate, name: keyof ITechnicianCertificate, value: string) => {
  techniciancertificate[name] = value;
  this.employeecertificateRegistry.set(techniciancertificate.id, techniciancertificate);
};

}

export default createContext(new EmployeeCertificateStore());
